module.exports = __webpack_public_path__ + "img/2_graph.24fb06cd.svg";